export const PENDING = 'pending';
export const CURRENT = 'current';
export const COMPLETED = 'completed';
export const ERROR = 'error';
